import React, { useState, useEffect } from "react";
import { auth, db } from "./firebase";
import { doc, getDoc, setDoc } from "firebase/firestore";

const SettingsScreen = ({ onClose, onSaved }) => {
  const [lineToken, setLineToken] = useState("");
  const [testUserId, setTestUserId] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [fetching, setFetching] = useState(true);

  useEffect(() => {
    const load = async () => {
      const user = auth.currentUser;
      if (!user) return setFetching(false);
      try {
        const snap = await getDoc(doc(db, "users", user.uid));
        if (snap.exists()) {
          const d = snap.data();
          setLineToken(d.lineToken || "");
          setTestUserId(d.testUserId || "");
        }
      } catch (err) {
        console.error("載入設定失敗:", err);
      } finally {
        setFetching(false);
      }
    };
    load();
  }, []);

  const handleSave = async (e) => {
    e.preventDefault();
    setError("");
    if (!lineToken.trim()) return setError("請輸入Channel access token");
    if (!testUserId.trim()) return setError("請輸入測試帳號 ID");
    const user = auth.currentUser;
    if (!user) return setError("未登入");
    setLoading(true);
    try {
      const config = { lineToken: lineToken.trim(), testUserId: testUserId.trim() };
      await setDoc(doc(db, "users", user.uid), config);
      onSaved?.({ token: config.lineToken, userId: config.testUserId });
      onClose();
    } catch (err) {
      setError("儲存失敗：" + err.message);
    } finally {
      setLoading(false);
    }
  };

  if (fetching) {
    return (
      <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.7)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 2000 }}>
        <div style={{ color: "#aaa", fontSize: 14 }}>載入中...</div>
      </div>
    );
  }

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.7)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 2000,
      }}
      onClick={(e) => e.target === e.currentTarget && onClose()}
    >
      <div
        style={{
          width: 400,
          padding: 32,
          background: "var(--bg-panel)",
          borderRadius: 12,
          border: "1px solid var(--border-color)",
          boxShadow: "0 10px 40px rgba(0,0,0,0.5)",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <h2 style={{ marginBottom: 20, color: "#fff", fontWeight: "600" }}>LINE 帳號設定</h2>
        <form onSubmit={handleSave} style={{ display: "flex", flexDirection: "column", gap: 16 }}>
          <div style={{ textAlign: "left" }}>
            <label style={{ display: "block", marginBottom: 6, fontSize: 13, color: "#aaa" }}>Channel access token</label>
            <input
              type="password"
              value={lineToken}
              onChange={(e) => setLineToken(e.target.value)}
              placeholder="LINE Channel Access Token"
              required
              style={{ width: "100%" }}
            />
          </div>
          <div style={{ textAlign: "left" }}>
            <label style={{ display: "block", marginBottom: 6, fontSize: 13, color: "#aaa" }}>測試帳號 ID</label>
            <input
              type="text"
              value={testUserId}
              onChange={(e) => setTestUserId(e.target.value)}
              placeholder="Target User ID（用於 Push 測試）"
              required
              style={{ width: "100%" }}
            />
          </div>
          {error && <div style={{ color: "#ef4444", fontSize: 13 }}>{error}</div>}
          <div style={{ display: "flex", gap: 10, marginTop: 8 }}>
            <button
              type="button"
              onClick={onClose}
              style={{
                flex: 1,
                padding: "12px",
                background: "#333",
                color: "#fff",
                border: "1px solid #555",
                borderRadius: 6,
                fontSize: 14,
                cursor: "pointer",
              }}
            >
              取消
            </button>
            <button
              type="submit"
              disabled={loading}
              style={{
                flex: 1,
                padding: "12px",
                background: "var(--accent-color)",
                color: "#fff",
                border: "none",
                borderRadius: 6,
                fontSize: 14,
                fontWeight: "600",
                cursor: loading ? "not-allowed" : "pointer",
                opacity: loading ? 0.7 : 1,
              }}
            >
              {loading ? "儲存中..." : "儲存"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SettingsScreen;
